import script from "./TablesView.vue?vue&type=script&lang=ts&setup=true"
export * from "./TablesView.vue?vue&type=script&lang=ts&setup=true"

import "./TablesView.vue?vue&type=style&index=0&id=48d29583&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48d29583"]])

export default __exports__